// tanstack
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$accountId/errorboundarydevtest')({
  component: RouteComponent,
});

function RouteComponent() {
  throw new Error(
    'This is a test error for the error boundary. It should be caught and displayed in the error boundary component.',
  );
}
